import {Directive, HostListener, Input} from '@angular/core';
import {NgControl} from '@angular/forms';

@Directive({selector: '[inputLowerCase]', standalone: false})
export class InputLowerCaseDirective {

    @Input() inputLowerCase: string = "";

    constructor(private readonly control: NgControl) {}

    @HostListener('input', ['$event']) onInput(event: any): void {
        if (this.control.control)
            this.control.control.setValue(event.target.value.toLowerCase());
    }
}
